import { ReminderInterval } from '../../enums/reminder/reminder-interval.enum';

export const ReminderIntervalTranslationMapper = new Map([
  [ReminderInterval.Never, 'REMINDER_INTERVAL.NEVER'],
  [ReminderInterval.Daily, 'REMINDER_INTERVAL.DAILY'],
  [ReminderInterval.TwiceAWeek, 'REMINDER_INTERVAL.TWICEAWEEK'],
  [ReminderInterval.Weekly, 'REMINDER_INTERVAL.WEEKLY'],
  [ReminderInterval.ADayBeforeExpiration, 'REMINDER_INTERVAL.ADAYBEFOREEXPIRATION'],
]);
